import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { createBrowserRouter, Route, RouterProvider } from 'react-router-dom'
import NotFound from './components/NotFound.tsx'
import Profile from './components/Profile.tsx'
import ListEditor from './components/ListEditor.tsx'
import ListBrowser from './components/ListBrowser.tsx'
import "sonner/dist/styles.css"
import ProtectedRoutes from './utils/ProtectedRoutes.tsx'

import ProfileLegacy from './components/ProfileLegacy.tsx'
import {

  QueryClientProvider,
} from '@tanstack/react-query'
import { queryClient } from './utils/ApiClient.tsx'
import ListViewer from './components/ListViewer.tsx'
import ConsumeLater from './components/ConsumeLater.tsx'
import TestLanding from './components/TestLanding.tsx'
import * as Sentry from "@sentry/react";
import Landing from './components/Landing.tsx'

Sentry.init({
  dsn: "https://78d57e4f097f9ab4bbc569d0adc5d942@o4509741670465536.ingest.us.sentry.io/4509743696707584",

  sendDefaultPii: true,
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "dark",
      autoInject: false,
    }),
  ]
});

document.title = "MediaHarbor"


const router = createBrowserRouter([
  {
    path: "/", 
    element: <App />, 
    children: [
      { path: "/", element: <Landing /> }, 
      { path: "/profile/:username", element: <Profile /> },
      { path: "/profile/legacy/:username", element: <ProfileLegacy /> },
      { path: "/consumelater/:username", element: <ConsumeLater /> },
      { path: "/list/all/:username", element: <ListBrowser /> },
      { path: "/list/view/:id", element: <ListViewer /> },
      { path: "/list/edit", element: <ListEditor /> },
      { path: "/list/edit/:id", element: <ListEditor /> },
   

      {
        element: <ProtectedRoutes />,
        children: [
         
        ]
      }
    ]
  },

  {
    path: "*",
    element: <NotFound />
  }
]);


createRoot(document.getElementById('root')!).render(
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router}/>
    </QueryClientProvider>
)
